module.exports = __webpack_public_path__ + "img/profile@2x.859939c.jpg";